module.exports = __webpack_public_path__ + "static/img/1.682f038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/Grinding/1.png
// module id = vxEB
// module chunks = 13